import React from "react";
import {
	Form,
	Input,
	InputNumber,
	Button,
} from "antd";
import Card from "components/card";
import TextArea from "antd/es/input/TextArea";
import { requiredField } from "utils/crudSagaHelper";

const PurchaseOrderItemForm = ({
	field,
	form,
	currency,
	getSymbol,
	remove,
	mode
}) => {
	const quantity =
		Number(
			form.getFieldValue([
				"items",
				field.name,
				"poi_quantity",
			])
		) || 1;

	const cost =
		Number(
			form.getFieldValue([
				"items",
				field.name,
				"poi_cost",
			])
		) || 0;

	const total = quantity * cost;

	return (
		<Card className="mb-4">
			<div className="grid grid-cols-3 gap-6">
				
				<div className="col-span-2">
					<Form.Item
						{...field}
						name={[field.name, "poi_item_name"]}
						label="Item Name"
						rules={[requiredField()]}
					>
						{mode !== "view" ? (
							<Input className="input-field" />
						) : (
							<label className="text-base label-value dark:text-white">
								{
									form.getFieldValue([
										"items",
										field.name,
										"poi_item_name",
									])
								}
							</label>
						)}
					</Form.Item>

					<Form.Item
						{...field}
						name={[field.name, "poi_description"]}
						label="Description"
					>
						{mode !== "view" ? (
							<TextArea
								rows={7}
								className="input-field"
							/>
						) : (
							<label className="text-base label-value dark:text-white">
								{
									form.getFieldValue([
										"items",
										field.name,
										"poi_description",
									])
								}
							</label>
						)}
					</Form.Item>
				</div>

				<div className="space-y-2">
					<Form.Item
						{...field}
						name={[field.name, "poi_quantity"]}
						label="Qty"
						initialValue={1}
						rules={[requiredField()]}
					>
						{mode !== "view" ? (
							<InputNumber
								min={1}
								className="input-field w-full"
							/>
						) : (
							<label className="text-base label-value dark:text-white">
								{quantity}
							</label>
						)}
					</Form.Item>

					<Form.Item
						{...field}
						name={[field.name, "poi_cost"]}
						label="Price"
						rules={[requiredField()]}
					>
						{mode !== "view" ? (
							<InputNumber
								min={0}
								className="input-field w-full"
							/>
						) : (
							<label className="text-base label-value dark:text-white">
								{getSymbol(currency)}
								{cost.toLocaleString()}
							</label>
						)}
					</Form.Item>

					<div>
						<p className="text-sm muted-text mb-1">
							Total Amount
						</p>

						<div className="border rounded-xl px-4 py-3 bg-gray-50">
							<h2 className="text-2xl font-bold title-text">
								{getSymbol(currency)}
								{total.toLocaleString(undefined, {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})}
							</h2>
						</div>
					</div>

					{mode !== "view" && (
						<Button
							danger
							block
							onClick={() => remove(field.name)}
						>
							Remove Item
						</Button>
					)}
				</div>
			</div>
		</Card>
	);
};

export default PurchaseOrderItemForm;